// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.m8TE7RI3ck6xoM0Q_A5_ {
    color: #fff;
    background: rgb(var(--accent-brand));
    border: 0;
    border-radius: 10px 0 0 10px;
    z-index: 555;
}

.m8TE7RI3ck6xoM0Q_A5_ > button {
    color: #fff !important;
}

/*--------------------new design--------------------*/
    .cb_XQQqc6ZHVmR_8e2hT {
        background: rgb(var(--secondary-bg));
        border-radius: 32px;
        padding: 16px 12px 12px 12px;
        position: relative;
        margin-bottom: 24px;
        overflow: hidden;
    }

    .GthrUQIrw1HH5jfSmblw {
        /* display: grid;
        grid-template-columns: auto 1.5fr auto;
        gap: 10px; */
        width: 100%;
        /* position: relative; */
        display: flex;
        flex-direction: row;
        justify-content: space-between;
    }

    .OGHzI9aBeRxsiyDD0pOn {
        position: absolute !important;
    }

    .lwIMhcM2aMPPOT4IbPPw {
        position: absolute;
        top: 20px;
        left: 0;
        height: 94%;
        width: 100%;
        z-index: 0;
    }
    .lwIMhcM2aMPPOT4IbPPw > svg {
        width: 100%;
        height: 100%;
    }

    .uLy9Bsv9ua2aLedkqy6w {
        width: 100%;
        border: none;
        z-index: 5;
        border-radius: 16px;
        padding: 8px;
        background: #40454A;
        color: rgb(var(--placeholder-primary));
        cursor: pointer;
        transition: outline 0.3s ease 0s;
        word-break: break-all;
        font-size: 14.5px;
        width: max-content;
        display: flex;
        z-index: 5;
        position: relative;
        justify-content: center;
    }
    .uLy9Bsv9ua2aLedkqy6w:active {
        outline: 1px solid rgb(var(--placeholder-tertiary));
    }

    /* .headerAddress:hover {
        outline: 1px solid rgb(var(--placeholder-tertiary));
    } */

    @media (max-width: 350px) {
        .uLy9Bsv9ua2aLedkqy6w {
            font-size: 13px; 
        }
    }

    /* .headerAddress:hover {
        opacity: 0.9;
    } */

    .BvA26OcAd2HmvjDSJdXF {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 8px;
    }
    
    .BvA26OcAd2HmvjDSJdXF > svg {
        min-width: 20px;
        min-height: 20px;
    }

    /*--------------------header detail--------------------*/
    
    ._u_wooByAOjbPlOITJrW {
        position: absolute;
        z-index: 110;
        width: calc(100% - 24px);
        max-width: 340px;
        top: 16px;
        left: 50%;
        transform: translate(-50%);
        border-radius: 28px;
        background: rgba(var(--tertiary-bg), 0.40);
        backdrop-filter: blur(40px);
        -webkit-backdrop-filter: blur(40px); 
        padding: 12px 16px 19px 16px;
    }

    .OU7F7nFv3abqscIkcjtd {
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 12px;
        /* margin-bottom: 12px; */
    }

    .OU7F7nFv3abqscIkcjtd > img {
        width: 48px;
        height: 48px;
        object-fit: contain;
        border-radius: 50%;
    }

    .OU7F7nFv3abqscIkcjtd > svg {
        min-width: 20px;
        min-height: 20px;
        max-width: 20px;
        max-height: 20px;
    }

    .Sx4pTnB60CSf2f8q3IUe {
        font-size: 18px;
        font-weight: 540;
    }

    .w6_5TJllW8MRBww5TFw5 {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 10px;
    }

    .yoQhWJ93_lljVKeWnRkO {
        font-size: 15px;
        color: rgb(var(--placeholder-tertiary));
    }

    .DuVbMHZJWFBfWgMqHfx5 {
        display: flex;
        align-items: center;
        gap: 4px;
        font-size: 15px;
        z-index: 51;
        position: relative;
        cursor: pointer;
    }

    /* .headerDetailItem:not(:last-child) {
        padding-bottom: 6px;
    }

    .headerDetailItem:last-child {
        padding-top: 8px;
    } */
    /*--------------------/header detail--------------------*/

    .CuuclszeC7BusxZOrGDf {
        font-size: 50px;
        position: relative;
        z-index: 2;
        color: rgb(var(--placeholder-primary));
        font-weight: 540;
        text-align: center;
        margin: 13px 0 24px 0;
        font-family: SF-PRO
    }

    .DrNiD7VylsgQLXdwlBhN {
        font-size: 32px !important;
    }

    .snOW1m9GfmOVj496z8RX {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 10px 8px;
        border-radius: 28px;
        background: rgba(64, 69, 74, 0.40);
        position: relative;
        z-index: 1;
        backdrop-filter: blur(28.950000762939453px);
        -webkit-backdrop-filter: blur(28.9px); 
    }

    .AFfFLP5TuOy3R4BLl2BQ {
        display: flex;
        flex-direction: column;
        gap: 8px;
        align-items: center;
        justify-content: center;
        z-index: 1;
        position: relative;
        background: none;
        font-size: 14px;
        font-weight: 400;
        font-family: 'Inter';
        transition: background 0.3s ease 0s;
        cursor: pointer;
        border: none;
        box-shadow: none;
        padding: 5px 16px;
        color: rgb(var(--placeholder-primary));
        border-radius: 16px;
    }

    .AFfFLP5TuOy3R4BLl2BQ:active {
        background: rgba(var(--placeholder-tertiary), 0.2);
    }

    /* .headerActionButton:hover {
        background: rgba(var(--placeholder-tertiary), 0.2);
    } */

    .AdHzM7czVRSyNjOLQ_bb {
        width: 1px;
        height: 53px;
        background: rgb(var(--placeholder-primary));
        opacity: 0.1;
    }

    @media (max-width: 350px) {
        .AdHzM7czVRSyNjOLQ_bb {
            display: none;
        }
        .AFfFLP5TuOy3R4BLl2BQ {
            padding: 5px 10px;
        }
    }

    .m4BebPOk2oQxWdwijRTu {
        width: 44px;
        height: 44px;
        border-radius: 50%;
        padding: 0;
        background: rgb(var(--accent-brand));
        /* position: absolute; */
        z-index: 2;

        display: flex;
        justify-content: center;
        align-items: center;

        border: none;
        box-shadow: none;
    }
    
    .m4BebPOk2oQxWdwijRTu:active {
        outline: 1px solid rgb(var(--placeholder-tertiary));
    }
    
    /* .actionButton:hover {
        outline: 1px solid rgb(var(--placeholder-tertiary));
    } */

    .CJOr72knfqlgoXY7WhFb {
        background: #40454A;
        cursor: pointer;
    }
/*--------------------/new design--------------------*/`, "",{"version":3,"sources":["webpack://./src/pages/main/main-header/main-header.module.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,oCAAoC;IACpC,SAAS;IACT,4BAA4B;IAC5B,YAAY;AAChB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA,qDAAqD;IACjD;QACI,oCAAoC;QACpC,mBAAmB;QACnB,4BAA4B;QAC5B,kBAAkB;QAClB,mBAAmB;QACnB,gBAAgB;IACpB;;IAEA;QACI;;oBAEY;QACZ,WAAW;QACX,wBAAwB;QACxB,aAAa;QACb,mBAAmB;QACnB,8BAA8B;IAClC;;IAEA;QACI,6BAA6B;IACjC;;IAEA;QACI,kBAAkB;QAClB,SAAS;QACT,OAAO;QACP,WAAW;QACX,WAAW;QACX,UAAU;IACd;IACA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,UAAU;QACV,mBAAmB;QACnB,YAAY;QACZ,mBAAmB;QACnB,sCAAsC;QACtC,eAAe;QACf,gCAAgC;QAChC,qBAAqB;QACrB,iBAAiB;QACjB,kBAAkB;QAClB,aAAa;QACb,UAAU;QACV,kBAAkB;QAClB,uBAAuB;IAC3B;IACA;QACI,mDAAmD;IACvD;;IAEA;;OAEG;;IAEH;QACI;YACI,eAAe;QACnB;IACJ;;IAEA;;OAEG;;IAEH;QACI,aAAa;QACb,mBAAmB;QACnB,uBAAuB;QACvB,QAAQ;IACZ;;IAEA;QACI,eAAe;QACf,gBAAgB;IACpB;;IAEA,wDAAwD;;IAExD;QACI,kBAAkB;QAClB,YAAY;QACZ,wBAAwB;QACxB,gBAAgB;QAChB,SAAS;QACT,SAAS;QACT,0BAA0B;QAC1B,mBAAmB;QACnB,0CAA0C;QAC1C,2BAA2B;QAC3B,mCAAmC;QACnC,4BAA4B;IAChC;;IAEA;QACI,eAAe;QACf,aAAa;QACb,mBAAmB;QACnB,uBAAuB;QACvB,SAAS;QACT,yBAAyB;IAC7B;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,mBAAmB;QACnB,kBAAkB;IACtB;;IAEA;QACI,eAAe;QACf,gBAAgB;QAChB,eAAe;QACf,gBAAgB;IACpB;;IAEA;QACI,eAAe;QACf,gBAAgB;IACpB;;IAEA;QACI,aAAa;QACb,mBAAmB;QACnB,8BAA8B;QAC9B,SAAS;IACb;;IAEA;QACI,eAAe;QACf,uCAAuC;IAC3C;;IAEA;QACI,aAAa;QACb,mBAAmB;QACnB,QAAQ;QACR,eAAe;QACf,WAAW;QACX,kBAAkB;QAClB,eAAe;IACnB;;IAEA;;;;;;OAMG;IACH,yDAAyD;;IAEzD;QACI,eAAe;QACf,kBAAkB;QAClB,UAAU;QACV,sCAAsC;QACtC,gBAAgB;QAChB,kBAAkB;QAClB,qBAAqB;QACrB;IACJ;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,aAAa;QACb,mBAAmB;QACnB,8BAA8B;QAC9B,iBAAiB;QACjB,mBAAmB;QACnB,kCAAkC;QAClC,kBAAkB;QAClB,UAAU;QACV,2CAA2C;QAC3C,qCAAqC;IACzC;;IAEA;QACI,aAAa;QACb,sBAAsB;QACtB,QAAQ;QACR,mBAAmB;QACnB,uBAAuB;QACvB,UAAU;QACV,kBAAkB;QAClB,gBAAgB;QAChB,eAAe;QACf,gBAAgB;QAChB,oBAAoB;QACpB,mCAAmC;QACnC,eAAe;QACf,YAAY;QACZ,gBAAgB;QAChB,iBAAiB;QACjB,sCAAsC;QACtC,mBAAmB;IACvB;;IAEA;QACI,kDAAkD;IACtD;;IAEA;;OAEG;;IAEH;QACI,UAAU;QACV,YAAY;QACZ,2CAA2C;QAC3C,YAAY;IAChB;;IAEA;QACI;YACI,aAAa;QACjB;QACA;YACI,iBAAiB;QACrB;IACJ;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,kBAAkB;QAClB,UAAU;QACV,oCAAoC;QACpC,wBAAwB;QACxB,UAAU;;QAEV,aAAa;QACb,uBAAuB;QACvB,mBAAmB;;QAEnB,YAAY;QACZ,gBAAgB;IACpB;;IAEA;QACI,mDAAmD;IACvD;;IAEA;;OAEG;;IAEH;QACI,mBAAmB;QACnB,eAAe;IACnB;AACJ,sDAAsD","sourcesContent":[".alert {\n    color: #fff;\n    background: rgb(var(--accent-brand));\n    border: 0;\n    border-radius: 10px 0 0 10px;\n    z-index: 555;\n}\n\n.alert > button {\n    color: #fff !important;\n}\n\n/*--------------------new design--------------------*/\n    .header {\n        background: rgb(var(--secondary-bg));\n        border-radius: 32px;\n        padding: 16px 12px 12px 12px;\n        position: relative;\n        margin-bottom: 24px;\n        overflow: hidden;\n    }\n\n    .headerTop {\n        /* display: grid;\n        grid-template-columns: auto 1.5fr auto;\n        gap: 10px; */\n        width: 100%;\n        /* position: relative; */\n        display: flex;\n        flex-direction: row;\n        justify-content: space-between;\n    }\n\n    .actionQr {\n        position: absolute !important;\n    }\n\n    .headerBg {\n        position: absolute;\n        top: 20px;\n        left: 0;\n        height: 94%;\n        width: 100%;\n        z-index: 0;\n    }\n    .headerBg > svg {\n        width: 100%;\n        height: 100%;\n    }\n\n    .headerAddress {\n        width: 100%;\n        border: none;\n        z-index: 5;\n        border-radius: 16px;\n        padding: 8px;\n        background: #40454A;\n        color: rgb(var(--placeholder-primary));\n        cursor: pointer;\n        transition: outline 0.3s ease 0s;\n        word-break: break-all;\n        font-size: 14.5px;\n        width: max-content;\n        display: flex;\n        z-index: 5;\n        position: relative;\n        justify-content: center;\n    }\n    .headerAddress:active {\n        outline: 1px solid rgb(var(--placeholder-tertiary));\n    }\n\n    /* .headerAddress:hover {\n        outline: 1px solid rgb(var(--placeholder-tertiary));\n    } */\n\n    @media (max-width: 350px) {\n        .headerAddress {\n            font-size: 13px; \n        }\n    }\n\n    /* .headerAddress:hover {\n        opacity: 0.9;\n    } */\n\n    .headerAddressInner {\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        gap: 8px;\n    }\n    \n    .headerAddressInner > svg {\n        min-width: 20px;\n        min-height: 20px;\n    }\n\n    /*--------------------header detail--------------------*/\n    \n    .headerDetail {\n        position: absolute;\n        z-index: 110;\n        width: calc(100% - 24px);\n        max-width: 340px;\n        top: 16px;\n        left: 50%;\n        transform: translate(-50%);\n        border-radius: 28px;\n        background: rgba(var(--tertiary-bg), 0.40);\n        backdrop-filter: blur(40px);\n        -webkit-backdrop-filter: blur(40px); \n        padding: 12px 16px 19px 16px;\n    }\n\n    .headerDetailTop {\n        cursor: pointer;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        gap: 12px;\n        /* margin-bottom: 12px; */\n    }\n\n    .headerDetailTop > img {\n        width: 48px;\n        height: 48px;\n        object-fit: contain;\n        border-radius: 50%;\n    }\n\n    .headerDetailTop > svg {\n        min-width: 20px;\n        min-height: 20px;\n        max-width: 20px;\n        max-height: 20px;\n    }\n\n    .headerDetailUsername {\n        font-size: 18px;\n        font-weight: 540;\n    }\n\n    .headerDetailItem {\n        display: flex;\n        align-items: center;\n        justify-content: space-between;\n        gap: 10px;\n    }\n\n    .headerDetailLeft {\n        font-size: 15px;\n        color: rgb(var(--placeholder-tertiary));\n    }\n\n    .headerDetailRight {\n        display: flex;\n        align-items: center;\n        gap: 4px;\n        font-size: 15px;\n        z-index: 51;\n        position: relative;\n        cursor: pointer;\n    }\n\n    /* .headerDetailItem:not(:last-child) {\n        padding-bottom: 6px;\n    }\n\n    .headerDetailItem:last-child {\n        padding-top: 8px;\n    } */\n    /*--------------------/header detail--------------------*/\n\n    .headerBalance {\n        font-size: 50px;\n        position: relative;\n        z-index: 2;\n        color: rgb(var(--placeholder-primary));\n        font-weight: 540;\n        text-align: center;\n        margin: 13px 0 24px 0;\n        font-family: SF-PRO\n    }\n\n    .smallSizeHeader {\n        font-size: 32px !important;\n    }\n\n    .headerActions {\n        display: flex;\n        align-items: center;\n        justify-content: space-between;\n        padding: 10px 8px;\n        border-radius: 28px;\n        background: rgba(64, 69, 74, 0.40);\n        position: relative;\n        z-index: 1;\n        backdrop-filter: blur(28.950000762939453px);\n        -webkit-backdrop-filter: blur(28.9px); \n    }\n\n    .headerActionButton {\n        display: flex;\n        flex-direction: column;\n        gap: 8px;\n        align-items: center;\n        justify-content: center;\n        z-index: 1;\n        position: relative;\n        background: none;\n        font-size: 14px;\n        font-weight: 400;\n        font-family: 'Inter';\n        transition: background 0.3s ease 0s;\n        cursor: pointer;\n        border: none;\n        box-shadow: none;\n        padding: 5px 16px;\n        color: rgb(var(--placeholder-primary));\n        border-radius: 16px;\n    }\n\n    .headerActionButton:active {\n        background: rgba(var(--placeholder-tertiary), 0.2);\n    }\n\n    /* .headerActionButton:hover {\n        background: rgba(var(--placeholder-tertiary), 0.2);\n    } */\n\n    .headerDivider {\n        width: 1px;\n        height: 53px;\n        background: rgb(var(--placeholder-primary));\n        opacity: 0.1;\n    }\n\n    @media (max-width: 350px) {\n        .headerDivider {\n            display: none;\n        }\n        .headerActionButton {\n            padding: 5px 10px;\n        }\n    }\n\n    .actionButton {\n        width: 44px;\n        height: 44px;\n        border-radius: 50%;\n        padding: 0;\n        background: rgb(var(--accent-brand));\n        /* position: absolute; */\n        z-index: 2;\n\n        display: flex;\n        justify-content: center;\n        align-items: center;\n\n        border: none;\n        box-shadow: none;\n    }\n    \n    .actionButton:active {\n        outline: 1px solid rgb(var(--placeholder-tertiary));\n    }\n    \n    /* .actionButton:hover {\n        outline: 1px solid rgb(var(--placeholder-tertiary));\n    } */\n\n    .actionButtonReload {\n        background: #40454A;\n        cursor: pointer;\n    }\n/*--------------------/new design--------------------*/"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"alert": `m8TE7RI3ck6xoM0Q_A5_`,
	"header": `cb_XQQqc6ZHVmR_8e2hT`,
	"headerTop": `GthrUQIrw1HH5jfSmblw`,
	"actionQr": `OGHzI9aBeRxsiyDD0pOn`,
	"headerBg": `lwIMhcM2aMPPOT4IbPPw`,
	"headerAddress": `uLy9Bsv9ua2aLedkqy6w`,
	"headerAddressInner": `BvA26OcAd2HmvjDSJdXF`,
	"headerDetail": `_u_wooByAOjbPlOITJrW`,
	"headerDetailTop": `OU7F7nFv3abqscIkcjtd`,
	"headerDetailUsername": `Sx4pTnB60CSf2f8q3IUe`,
	"headerDetailItem": `w6_5TJllW8MRBww5TFw5`,
	"headerDetailLeft": `yoQhWJ93_lljVKeWnRkO`,
	"headerDetailRight": `DuVbMHZJWFBfWgMqHfx5`,
	"headerBalance": `CuuclszeC7BusxZOrGDf`,
	"smallSizeHeader": `DrNiD7VylsgQLXdwlBhN`,
	"headerActions": `snOW1m9GfmOVj496z8RX`,
	"headerActionButton": `AFfFLP5TuOy3R4BLl2BQ`,
	"headerDivider": `AdHzM7czVRSyNjOLQ_bb`,
	"actionButton": `m4BebPOk2oQxWdwijRTu`,
	"actionButtonReload": `CJOr72knfqlgoXY7WhFb`
};
export default ___CSS_LOADER_EXPORT___;
